import { useTranslation } from 'react-i18next'
import './FluidSpecs.css'
import { FluidItem } from '../../types'

interface FluidSpecsProps {
  items: FluidItem[]
}

export default function FluidSpecs({ items }: FluidSpecsProps) {
  const { t } = useTranslation()
  if (items.length === 0) return null

  return (
    <div className="fluid-specs">
      <h3 className="fluid-specs__label">{t('fluid_specs.title')}</h3>
      <div className="fluid-specs__card">
        {items.map((item, index) => (
          <div key={item.key}>
            {index > 0 && <div className="fluid-specs__divider" />}
            <div className="fluid-specs__row">
              <div className="fluid-specs__left">
                <span className="fluid-specs__name">{item.name}</span>
                {item.specs ? (
                  <span className="fluid-specs__grade">{item.specs.fluidGrade}</span>
                ) : (
                  <span className="fluid-specs__no-data">{t('fluid_specs.no_data')}</span>
                )}
              </div>
              <div className="fluid-specs__right">
                {item.specs ? (
                  <>
                    <span className="fluid-specs__capacity">{item.specs.capacity}</span>
                    <span className="fluid-specs__interval">{item.specs.changeInterval}</span>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
